import { Outlet } from "react-router-dom";
import "./TopLinks.css";

export const TopLinks = ({ links }: any) => {
    return (
        <>
            <Outlet />
        </>
    )
};